// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchStreamIdParams = {
    authToken: string,
    catalogId: number,
    deployment: string,
};

export default {
    fetchStreamId: ({ authToken, catalogId, deployment }: FetchStreamIdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `status/${catalogId}`,
                authToken,
                deployment,
                path: '<STREAM-MANAGER>',
            });

            request.end((err, response) =>
                handleResponseOld({
                    err,
                    reject,
                    resolve,
                    response,
                }),
            );
        }),
};
